:host {
  display: block;
}

.disclaimer {
  display: flex;
  flex-direction: row;
  gap: 4px;
  font-size: 0.9em;
  text-align: left;
}

input[type="checkbox"]:focus-visible, a:focus-visible {
  outline-color: var(--av-color-focus-outline);
}
